import { browserHistory } from 'react-router';

import nuc from '../../../../../shared/utils/nuc';
import type { ImportRepositoriesResponse } from '../../../../../shared/types/routes/vcs/githubApp';
import type {
  ImportGitHubAppRepositoriesVariables,
} from '../../../../hooks/api/vcs/githubApp/useImportGitHubAppRepositories';

/**
 * Lands a lone imported repo on its project, mirroring the legacy import flow: a new import
 * creates the repo's own locator, a connect attaches its one matched project. Several repos, a
 * batch queued in the background, or a repo matching several projects stay on the import page.
 */
export const openSingleImportedProject = (
  { queued }: ImportRepositoriesResponse,
  { repos }: ImportGitHubAppRepositoriesVariables,
) => {
  const [repo] = repos;
  if (!repo || repos.length > 1 || queued || repo.connectableProjects.length > 1) {
    return;
  }
  browserHistory.push(`/projects/${nuc(repo.connectableProjects[0] ?? repo.locator)}`);
};
